module.exports = __webpack_public_path__ + "img/jiangxi.6fb29c0a.png";